const _CHUNK_DELAY = 16;
const _CHUNK_SIZE = 16;

/**
 * A *very* partial implementation of EventSource structure with the idea of giving an effect of gradual
 * answer streaming from the backend.
 */
export default class MockChatbotEventSource {
    constructor(answer, nextBestQuestions) {
        this.nextBestQuestions = nextBestQuestions;

        this.chunks = this.stringToChunks(answer);
        this.chunkCount = this.chunks.length;
        this.chunkIndex = 0;

        this.intervalID = setInterval(() => {
            this.sendChunk();
        }, _CHUNK_DELAY);

        // { [key: EventName]: Array<Function> }
        this.listeners = Object.seal({
            message: [],
            error: [],
        });
    }

    addEventListener(eventName, callback) {
        if (!Array.isArray(this.listeners[eventName])) {
            throw new Error(`Unknown event '${eventName}' given to MockChatbotEventSource!`);
        }

        this.listeners[eventName].push(callback);
    }

    close() {
        clearInterval(this.intervalID);

        this.chunks = [];
        this.chunkCount = 0;
        this.chunkIndex = 0;

        this.intervalID = null;
    }

    sendChunk() {
        const isLast = this.chunkIndex === this.chunkCount - 1;
        const data = JSON.stringify({
            answer: this.chunks[this.chunkIndex],
            last_response: isLast,
            next_best_questions: isLast ? this.nextBestQuestions : [],
        });

        for (const listener of this.listeners.message) {
            listener({ data });
        }

        if (isLast) {
            this.close();
            return;
        }

        ++this.chunkIndex;
    }

    stringToChunks(input) {
        const chunks = [];
        const len = input.length;
        const size = _CHUNK_SIZE;

        for (let i = 0; i < len; i += size) {
            chunks.push(input.slice(i, i + size));
        }

        return chunks;
    }
}
